import React from "react";
import "./login.css";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { Label, TextField, Checkbox } from "@fluentui/react";
import axios from "axios";
import { useMutation } from "react-query";
import { Link, useNavigate } from "react-router-dom";
import SpinningLoader from "../Loaders/SpinningLoader";
import { textFieldStyles } from "styles/formStyles";

const loginEmployee = async (data) => {
  const response = await axios.post(
    "https://gxiv4d2ndh.execute-api.us-east-1.amazonaws.com/dev/login",
    data,
    { headers: { "Content-Type": "application/json" } }
  );
  return response.data;
};

const LoginForm = () => {
  const navigate = useNavigate();

  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [isEmployer, setIsEmployer] = React.useState(false);
  const { mutate, isLoading } = useMutation(loginEmployee, {
    onSuccess: (data) => {
      localStorage.setItem("userEmail", email);
      localStorage.setItem("isEmployer", isEmployer);

      isEmployer ? navigate("/task-dashboard") : navigate("/user/task-details");
    },
    onError: (err) => {
      if (err?.response?.status === 404 && !err?.response?.data?.success) {
        alert(err?.response?.data?.err);
        return;
      }
      alert(err?.message);
    },
  });

  const homePage = (event) => {
	  window.location.href='https://www.unigenioussoft.com/';
  }

  const handleLoginQuery = (event) => {
    event.preventDefault();
    if (!email || !password) {
      alert("Email and Password both fields are required!");
      return;
    }
    let dataBody = {
      email: email,
      password: password,
      group: isEmployer ? "employer" : "employee",
    };
    mutate(dataBody);
  };

  return (
    <>
      <div className="main-container">
        <div className="signBtn">

	  <PrimaryButton className="sign-up-btn"
                 onClick={(e) => homePage(e)}> Home Page </PrimaryButton>
              


          <PrimaryButton className="sign-up-btn" onClick={() => navigate("/")}>
            SIGN UP
          </PrimaryButton>
        </div>

        <div className="inputData">
          <form noValidate>
            <div className="fields">
              <Label htmlFor="exampleFormControlInput1" className="form-label">
                <u>Employee Login:</u>
              </Label>
              <TextField
                type="email"
                className="form-control"
                id="exampleFormControlInput1"
                name="FullName"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                styles={textFieldStyles}
              />
            </div>
            <br />
            <div className="fields">
              <Label htmlFor="exampleFormControlInput2" className="form-label">
                <u>Password:</u>
              </Label>
              <TextField
                type="password"
                className="form-control"
                id="exampleFormControlInput2"
                name="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                styles={textFieldStyles}
              />
            </div>

            <br />

            <Checkbox
              className="checkBox"
              label="Employer: &nbsp; &nbsp;"
              boxSide="end"
              value={true}
              onChange={(e) => setIsEmployer(!isEmployer)}
            />

            <div className="loginBtn">
              <Link to="/forgot-password">
                <span className="forgotPass">
                  <u>Forgot Password?</u>
                </span>
              </Link>
              <div className="btn_bg">
                <PrimaryButton
                  disabled={isLoading}
                  className="clrChange"
                  onClick={handleLoginQuery}
                >
                  <i
                    className="ms-Icon ms-Icon--MSNVideos"
                    aria-hidden="true"
                  ></i>
                  &nbsp;&nbsp; L o g i n
                </PrimaryButton>
              </div>
              <span className="resetPass">
                <u>Reset Password</u>
              </span>
            </div>
          </form>
        </div>
        <SpinningLoader isLoading={isLoading} />
      </div>
    </>
  );
};
export default LoginForm;
